module.exports = __webpack_public_path__ + "img/Inspection8.6b7ea941.png";